<template>
  <div class="d-flex align-center select-container">
    <v-select
      class="custom-vt-select ma-auto"
      dense
      :height="height"
      v-model="duration"
      :items="items"
      item-text="label"
      return-object
      @change="update_duration"
    />
    <v-divider class="remove-margin" vertical />
    <div class="left-border select-dates titleLight--text">
      {{ time_duration }}
    </div>
  </div>
</template>

<script>
export default {
  name: "InputSelectVT",
  props: { height: String, items: Array },
  data: function () {
    return {
      currentValue: null,
      currentDuration: null,
      time_duration: "",
    };
  },
  mounted() {
    let current_value = this.items && this.items[0] && this.items[0].value;
    this.currentDuration = this.items && this.items[0] && this.items[0].value;
    this.currentValue =
      this.items && this.items[0] && this.items[0].type == "week"
        ? current_value * 7
        : current_value;
    this.update_duration();
  },
  methods: {
    update_duration() {
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var toDateObj = new Date();
      var fromDateObj = new Date();
      // subtract one day from current time
      fromDateObj.setDate(fromDateObj.getDate() - this.currentValue);
      this.time_duration =
        fromDateObj.getDate() +
        " " +
        months[fromDateObj.getMonth()] +
        " - " +
        toDateObj.getDate() +
        " " +
        months[toDateObj.getMonth()];
    },
  },
  computed: {
    duration: {
      get: function () {
        return this.currentDuration;
      },
      set: function (newValue) {
        this.currentDuration = newValue.value;
        this.currentValue =
          newValue.type && newValue.type == "week"
            ? newValue.value * 7
            : newValue.value;
        this.$emit("value_changes", newValue.value);
        return newValue.value;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.select-container {
  border: solid 1px var(--v-borderLight-base);
  border-radius: 4px;
  font-size: 14px;
  letter-spacing: 0em;

  .remove-margin.v-divider {
    border-color: var(--v-borderLight-base);
    margin: 0;
  }

  div.select-dates,
  div.custom-vt-select {
    padding: 0.25em;
  }
  ::v-deep .custom-vt-select.v-text-field.v-text-field--is-booted {
    width: 50%;
    font-size: 14px;
    margin: 0;
    .v-text-field__details,
    .v-text-field__details {
      .v-messages {
        min-height: 0;
      }

      margin: 0;
      padding: 0;
      min-height: 0;
    }
    .v-input__control {
      .v-input__slot::before,
      .v-input__slot::after {
        border: none;
      }
      .v-input__slot .v-icon {
        margin-top: 0;
      }
    }
  }
}
</style>
